import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import * as hiredCarsSource from "sources/books/hiredCars";
import * as hiredDriversSource from "sources/books/hiredDrivers";
import * as hiredTrailersSource from "sources/books/hiredTrailers";
import CarsList from "./cars/list";
import CarsShow from "./cars/show";
import DriversList from "./drivers/list";
import DriversShow from "./drivers/show";
import TrailersList from "./trailers/list";
import TrailersShow from "./trailers/show";

export default class HiredPark extends Component {
    componentWillUnmount() {
        this.props.clearParams("hired-cars");
        this.props.clearParams("hired-trailers");
        this.props.clearParams("hired-drivers");
    }

    render() {
        const { match, location, history } = this.props;
        const carsRoot = `${match.path}/cars`;
        const trailersRoot = `${match.path}/trailers`;
        const driversRoot = `${match.path}/drivers`;

        return (
            <div className="page-content">
                <Switch location={location}>
                    <Route
                        exact
                        path={carsRoot}
                        render={() => (
                            <CarsList
                                {...this.props}
                                isTable
                                transition="full"
                                title="Наёмные машины"
                                nofilter
                                source={hiredCarsSource}
                            />
                        )}
                    />
                    <Route
                        path={`${carsRoot}/:id`}
                        render={(rest) => (
                            <CarsShow
                                {...rest}
                                transition="full"
                                title="Наёмный автомобиль"
                                back={() => history.push(carsRoot)}
                                source={hiredCarsSource}
                            />
                        )}
                    />
                    <Route
                        exact
                        path={trailersRoot}
                        render={() => (
                            <TrailersList
                                {...this.props}
                                isTable
                                transition="full"
                                title="Наёмные прицепы"
                                nofilter
                                source={hiredTrailersSource}
                            />
                        )}
                    />
                    <Route
                        path={`${trailersRoot}/:id`}
                        render={(rest) => (
                            <TrailersShow
                                {...rest}
                                transition="full"
                                title="Наёмный прицеп"
                                back={() => history.push(trailersRoot)}
                                source={hiredTrailersSource}
                            />
                        )}
                    />
                    <Route
                        exact
                        path={driversRoot}
                        render={() => (
                            <DriversList
                                {...this.props}
                                isTable
                                transition="full"
                                title="Наёмные водители"
                                nofilter
                                source={hiredDriversSource}
                            />
                        )}
                    />
                    <Route
                        path={`${driversRoot}/:id`}
                        render={(rest) => (
                            <DriversShow
                                {...rest}
                                transition="full"
                                title="Наёмный водитель"
                                back={() => history.push(driversRoot)}
                                source={hiredDriversSource}
                            />
                        )}
                    />
                    <Redirect to={carsRoot} />
                </Switch>
            </div>
        );
    }
}
